document.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('.slider').forEach(function (slider) {
        if ( initialSlide = slider.querySelector('.initial-slide')) {
            // slider.scrollTo({left:initialSlide.offsetLeft});
        }
    });
});

